'use client';

import { VStack } from '@cbhq/cds-web/layout';
import { memo, useMemo } from 'react';

import { useBreakpoints } from '@cbhq/cds-web/hooks/useBreakpoints';
import { PortfolioSummary } from '@/components/Portfolio/PortfolioSummary';
import { PortfolioPositions } from '@/components/Portfolio/PortfolioPositions';
import { PortfolioHeader } from '@/components/Portfolio/PortfolioHeader';
import { PortfolioHeaderButtons } from '@/components/Portfolio/PortfolioHeaderButtons';
import { USDCRewardsCard } from '@/components/Portfolio/USDCRewardsCard';
import { USDCRewardsEligibility, useUSDCRewards } from '@/hooks/useUSDCRewards';
import { TwoColumnLayout } from '@/components/common/TwoColumnLayout';
import { DEFAULT_CARD_SPACER } from '@/constants/layout';

export const PortfolioLayout = memo(function PortfolioLayout() {
  const { isPhone, isPhoneLandscape } = useBreakpoints();
  const showMobileLayout = useMemo(() => isPhone ?? isPhoneLandscape, [isPhone, isPhoneLandscape]);
  const usdcRewardsStatus = useUSDCRewards();
  const showRewardsCard = usdcRewardsStatus !== USDCRewardsEligibility.NA;

  // Mobile layout with header buttons at the bottom
  if (showMobileLayout) {
    return (
      <VStack width="100vw" background="bgAlternate">
        <TwoColumnLayout
          header={<PortfolioHeader />}
          main={
            <VStack gap={DEFAULT_CARD_SPACER}>
              <PortfolioSummary />
              <PortfolioPositions />
            </VStack>
          }
          sidebar={showRewardsCard ? <USDCRewardsCard /> : undefined}
          footer={<PortfolioHeaderButtons />}
        />
      </VStack>
    );
  }

  // Desktop layout
  return (
    <VStack flexGrow={1} background="bgAlternate">
      <TwoColumnLayout
        header={<PortfolioHeader />}
        main={
          <VStack gap={DEFAULT_CARD_SPACER}>
            <PortfolioSummary />
            <PortfolioPositions />
          </VStack>
        }
        sidebar={showRewardsCard ? <USDCRewardsCard /> : undefined}
      />
    </VStack>
  );
});
